import { useRef, useCallback } from "react";
import { PieChartRef } from "./PieChart";

export const usePieChartLegendHover = () => {
  const pieChartRef = useRef<PieChartRef>(null);

  const handleLegendHover = useCallback((pointName: string, isHovering: boolean) => {
    pieChartRef.current?.handleLegendHover(pointName, isHovering);
  }, []);

  return { pieChartRef, handleLegendHover };
};